import T from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import { be, bm } from '@skippay/core/utils/classUtils';

import { useAnalyticsEvent } from 'components/GoogleAnalytics';

import './index.sass';
import { getELabFromClick } from './utils';

const MODULE_NAME = 'Modal';

function Modal(props) {
	const {
		alignTop,
		centered,
		children,
		contentLabel,
		extraSmall,
		fullScreen,
		heightAuto,
		isOpen,
		large,
		onAfterOpen,
		displayOnTop,
		small,
		smaller,
		...other
	} = props;

	const sendEvent = useAnalyticsEvent({ eAct: contentLabel, eCat: `Modal Window`, eVal: 1 });

	return (
		<ReactModal
			{...other}
			className={bm(
				MODULE_NAME,
				{
					alignTop,
					centered,
					extraSmall,
					fullScreen,
					heightAuto,
					large,
					small,
					smaller,
				},
				other.className
			)}
			contentLabel={contentLabel}
			isOpen={isOpen}
			{...(displayOnTop && { portalClassName: 'ReactModalPortal--onTop' })}
			overlayClassName={be(MODULE_NAME, 'overlay')}
			ariaHideApp={process.env.NODE_ENV !== `test`}
			onAfterOpen={() => {
				onAfterOpen?.();
				sendEvent({ eInt: true, eLab: `Modal Shown` });
			}}
			closeTimeoutMS={300}
		>
			<div
				onClick={({ target }) => {
					const eLab = getELabFromClick(target);
					if (eLab) {
						sendEvent({ eInt: false, eLab });
					}
				}}
			>
				{children}
			</div>
		</ReactModal>
	);
}

Modal.propTypes = {
	/**
	 * For overview of all props see http://reactcommunity.org/react-modal/
	 */
	...ReactModal.propTypes,
	alignTop: T.bool,
	/**
	 * Used for screen-readers as well for google analytics tracking, thus required.
	 */
	centered: T.bool,
	contentLabel: T.string.isRequired,
	displayOnTop: T.bool,
	extraSmall: T.bool,
	fullScreen: T.bool,
	heightAuto: T.bool,
	onAfterOpen: T.func,
	onRequestClose: T.func,
	small: T.bool,
	smaller: T.bool,
};

export default Modal;
